import {assert} from 'Asserts';
import {ProcessExecutionType, ProcessClientOrigin} from 'graphql-client/__generated/graphqlGlobalTypes';
import {ListingRendererType} from 'nav/expanded/ListingRendererConstants';
import {isInDevelopmentExecutionType} from 'processes/ProcessConstants';
import {assertNever} from 'util/Types';

import {ProcessTaskListingGraphQL} from '../../../../../graphql-fragments/processes/__generated/ProcessTaskListingGraphQL';

export default function getListingRendererTypeForProcessTask(
  task: ProcessTaskListingGraphQL
): ListingRendererType {
  switch (task.schema.executionType) {
    case ProcessExecutionType.PROCEDURE:
      if (task.schema.clientOrigin === ProcessClientOrigin.ASSAYS) {
        return ListingRendererType.ASSAY_RUN_TASK;
      } else if (task.schema.clientOrigin === ProcessClientOrigin.RECIPES) {
        return ListingRendererType.RECIPE_RUN_TASK;
      } else {
        assert(false, `Unexpected task schema type ${task.schema.clientOrigin}`);
      }
      break;
    case ProcessExecutionType.PROCEDURE_METHOD:
      if (task.schema.clientOrigin === ProcessClientOrigin.ASSAYS) {
        return ListingRendererType.ASSAY_UNIT_OPERATION_TASK;
      } else if (task.schema.clientOrigin === ProcessClientOrigin.RECIPES) {
        return ListingRendererType.RECIPE_UNIT_OPERATION_TASK;
      } else {
        assert(false, `Unexpected task schema type ${task.schema.clientOrigin}`);
      }
      break;
    case ProcessExecutionType.PROCEDURE_STEP:
      if (task.schema.clientOrigin === ProcessClientOrigin.ASSAYS) {
        return ListingRendererType.ASSAY_STEP_TASK;
      } else if (task.schema.clientOrigin === ProcessClientOrigin.RECIPES) {
        return ListingRendererType.RECIPE_STEP_TASK;
      } else {
        assert(false, `Unexpected task schema type ${task.schema.clientOrigin}`);
      }
      break;
    case ProcessExecutionType.FLOWCHART:
    case ProcessExecutionType.ENTRY:
    case ProcessExecutionType.DIRECT:
      return ListingRendererType.PROCESS_TASK;
    default:
      if (isInDevelopmentExecutionType(task.schema.executionType)) {
        return ListingRendererType.PROCESS_TASK;
      }

      assert(false, `Unsupported task of execution type ${assertNever(task.schema.executionType)}.`);
  }
}
